<template>
  <v-container fluid class="py-0">
    <v-row justify="center">
      <v-col cols="12" class="pa-0">
        <v-card class="ma-2" v-if ="lAction === 'view'">
          <v-card-title class="title grey lighten-4 primary--text pa-2">
            <div>Open Tickets ({{ticketList.length}})</div>
          </v-card-title>
          <v-card-text class="pa-0">
            <template>
              <v-data-table
              :headers="ticketHead"
              :items="ticketList"
              disable-pagination
              hide-default-footer
              :mobile-breakpoint="0"
              sort-by="ticket_no"
              sort-desc
              >
              <template slot="item" slot-scope="props">
                <tr @click="prepareEdit(props.item)">
                  <td>{{ props.item.ticket_no }}</td>
                  <td>{{ handy.formatDate(props.item.ticket_dt) }}</td>
                  <td>{{ props.item.ticket_on }}</td>
                  <td>{{ props.item.comm_name }}</td>
                  <td>{{ props.item.ticket_title }}</td>
                  <td>{{ props.item.comp_by }}</td>
                  <td>{{ props.item.raised_mode }}</td>
                  <td>{{ props.item.ticket_status }}</td>
                </tr>
              </template>
            </v-data-table>
          </template>
        </v-card-text>
      </v-card>

      <v-btn
      :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:20px; right:15px;':'bottom:15px; right:15px;')"
      dark fab fixed color="accent" v-if="lAction === 'view'"
      @click.native="prepareCreate">
      <v-icon>mdi-plus</v-icon>
    </v-btn>

    <!-- 1. Create ticket -->
    <v-container v-if="lAction === 'create'" class="pt-0" fluid full-height>
      <v-layout row wrap>
        <v-flex xs12>
          <v-form ref="cForm" @submit.prevent="createTicket">
            <v-card flat>
              <v-flex xs12 sm9 mx-auto>
                <v-card-title class="title pb-0">
                  {{ handy.startWithUpper(lAction) }} Ticket
                </v-card-title>
                <v-card-title class="subtitle-1 primary--text">
                  Ticket From
                </v-card-title>
                <v-card-text>
                  <v-container grid-list-md class="pa-0">
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field class="pa-0"
                        v-model="lTicket.comp_phone"
                        label= "Phone Number"
                        hide-details
                        maxlength="15"
                        type="number"
                        @change="searchCustomerDet()"
                        :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                        label="Name"
                        v-model="lTicket.comp_by"
                        :rules="[rules.required]"
                        hide-details
                        maxlength="50"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-text-field
                        v-model="lTicket.contact_email"
                        label="E-mail"
                        :rules="[rules.required]"
                        hide-details
                        maxlength="50"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-select
                        v-model="lTicket.comm_id"
                        :items="commList"
                        label="Community Name"
                        item-text="comm_name"
                        item-value="comm_id"
                        hide-details
                        :rules="[rules.required]"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm6>
                        <v-select
                        v-model="lTicket.raised_mode"
                        :items="['Phone', 'E-mail']"
                        label="Raised Mode"
                        hide-details
                        :rules="[rules.required]"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 class="subtitle-1 primary--text pb-0 pt-3">
                        Ticket Details
                      </v-flex>
                      <v-flex xs12 class="pt-0">
                        <v-text-field
                        ref='title' v-model="lTicket.ticket_title"
                        label="Ticket title"
                        :rules="[rules.required]"
                        hide-details
                        maxlength="100"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-textarea
                        v-model="lTicket.ticket_desc"
                        label="Ticket description"
                        :rules="[rules.required]"
                        hide-details
                        rows="4"
                        maxlength="1000"
                        ></v-textarea>
                      </v-flex>
                      <v-flex xs12>
                        <v-switch
                        label="Critical"
                        v-model="lTicket.is_critical"
                        hide-details
                        ></v-switch>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions class="pt-0">
                  <v-spacer></v-spacer>
                  <v-btn @click.stop="cancel">Cancel</v-btn>
                  <v-btn type="submit" color="accent" :disabled="beingSaved">Log</v-btn>
                </v-card-actions>
              </v-flex>
            </v-card>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </v-col>
</v-row>

<!-- 2. Update/ resolve tickets -->
<v-dialog v-model="showResolve" scrollable max-width="500px">
  <v-form ref="lForm" @submit.prevent="saveChanges">
    <v-card scrollable>
      <v-card-title class="title pb-0">
        Update/Resolve Ticket
      </v-card-title>
      <v-card-text class="pb-1 body-1">
        <v-container grid-list-md class="pa-0">
          <v-layout row wrap>
            <v-flex xs12>
              <v-alert color="info">
                <span class="title font-weight-bold">{{ lTicket.ticket_title }}</span></br>
                <span class="subtitle-1">{{ lTicket.ticket_desc }}</span>
              </v-alert>
            </v-flex>
            <v-flex xs6>
              <span class="caption grey--text">Ticket No.</span><br />
              <span class="black--text">{{ lTicket.ticket_no }}</span>
            </v-flex>
            <v-flex xs6>
              <span class="caption grey--text">Ticket Date</span><br />
              <span class="black--text">{{ handy.formatDBDate(lTicket.ticket_dt)}}</span>
            </v-flex>
            <v-flex xs6>
              <span class="caption grey--text">Ticket On</span><br />
              <span class="black--text">{{lTicket.ticket_on}}</span>
            </v-flex>
            <v-flex xs6>
              <span class="caption grey--text">Complaint Phone</span><br />
              <span class="black--text">{{lTicket.comp_phone}}</span>
            </v-flex>
            <v-flex xs6>
              <span class="caption grey--text">Community Name</span><br />
              <span class="black--text">{{lTicket.comm_name}}</span>
            </v-flex>
            <v-flex xs6>
              <span class="caption grey--text">Contact Email</span><br />
              <span class="black--text">{{lTicket.contact_email}}</span>
            </v-flex>
            <v-flex xs12>
              <v-select
              v-model="lTicket.severity"
              label="Severity"
              :items="['Normal', 'Major', 'Critical']"
              :rules="[rules.required]"
              hide-details
              ></v-select>
            </v-flex>
            <v-flex xs6>
              <v-dialog
              ref="planclosedt"
              v-model="planclosedt"
              :return-value.sync="lTicket.plan_close_dt"
              persistent
              width="290px"
              >
              <template v-slot:activator="{ on }">
                <v-text-field
                v-model="lTicket.plan_close_dt"
                label="Plan Close Date"
                append-icon="mdi-calendar-today"
                readonly
                v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="lTicket.plan_close_dt" :min="today" scrollable>
                <div class="flex-grow-1"></div>
                <v-btn text color="primary" @click="planclosedt = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.planclosedt.save(lTicket.plan_close_dt)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-flex xs6>
            <v-dialog ref="actclosedt"
            persistent
            width="290px"
            v-model="actclosedt"
            :return-value.sync="lTicket.act_close_dt"
            >
            <template v-slot:activator="{ on }">
              <v-text-field
              label="Actual Close Date"
              v-model="lTicket.act_close_dt"
              append-icon="mdi-calendar-today"
              readonly
              v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="lTicket.act_close_dt" scrollable
            :min="today"
            >
            <div class="flex-grow-1"></div>
            <v-btn text @click="actclosedt = false">Cancel</v-btn>
            <v-btn text color="accent" @click="$refs.actclosedt.save(lTicket.act_close_dt)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
      </v-flex>
      <v-flex>
        <v-alert class="grey lighten-4 pa-2" outlined color="grey lighten-2">
          <v-layout>
            <v-flex xs6>
              <v-select
              v-model="lTicket.ticket_status"
              label="Status"
              :items="statusList"
              hide-details
              ></v-select>
            </v-flex>
            <v-flex xs6>
              <v-combobox
              v-model="lTicket.assigned_to"
              label="Assigned To"
              :items="mcList"
              item-text="user_name"
              item-value="user_id"
              ></v-combobox>
            </v-flex>
          </v-layout>
          <v-flex>
            <v-textarea
            outlined
            hide-details
            label="Notes/Resolution"
            rows="2"
            v-model="lTicket.notes">
          </v-textarea>
        </v-flex>
      </v-alert>
    </v-flex>
  </v-layout>
</v-container>
</v-card-text>
<v-card-actions>
  <v-btn text @click="loadTimeLine(lTicket.ticket_no)">Timeline</v-btn>
  <v-spacer></v-spacer>
  <v-btn text  @click.stop="cancelChanges">Cancel</v-btn>
  <v-btn text  type="submit" color="accent" :disabled="beingSaved">Save</v-btn>
</v-card-actions>
</v-card>
</v-form>
</v-dialog>

<!-- 3. show Timeline for particular ticket_no -->
<v-dialog v-model="showTimeline" scrollable max-width="500px">
  <v-card>
    <v-card-title class="py-1 title grey lighten-4">
      <div>Timeline</div>
      <v-spacer></v-spacer>
      <v-btn small icon @click.stop="showTimeline = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-card-title>
    <v-card-text class="pb-0">
      <v-timeline dense class="py-2">
        <v-timeline-item :class="n === lTimeLine.length-1 ? 'pb-0' : ''"
        v-for="(timeline, n) in lTimeLine"
        :key="n" small>
        <template v-slot:icon>
          <v-avatar>
            <img :src="handy.loadImg(timeline.avatar_url, true)">
          </v-avatar>
        </template>
        <v-card>
          <v-card-title class="title pa-2">
            {{ timeline.ticket_status }}
          </v-card-title>
          <v-card-text class="pt-0 pb-2">
            <div>{{ timeline.notes }}</div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="caption pa-2">
            {{ timeline.created_by }}
            <span class="grey--text pl-2">{{handy.formatDateTime(timeline.action_dt) }}</span>
          </v-card-actions>
        </v-card>
      </v-timeline-item>
    </v-timeline>
  </v-card-text>
</v-card>
</v-dialog>

<!-- snack bar for reporting -->
<v-snackbar :color="sbarCol" v-model="sbar"
:timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
</v-snackbar>
</v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'

export default{
  data () {
    return {
      lAction: 'view',
      // common
      handy: handy,
      config: config,
      rules: handy.rules,
      beingSaved: false,
      sbar: false,
      sbarCol: 'error',
      sbarMsg: '',
      inset: false,
      // tickets
      lTicket: {},
      ticketList: [],
      showResolve: false,
      planclosedt: false,
      actclosedt: false,
      mcList: [],
      statusList: ['New', 'Assigned', 'On-hold', 'In Progress', 'Resolved', 'Reopened'],
      ticketHead: [
        { text: 'Ticket No.', value: 'ticket_no' },
        { text: 'Ticket Date', value: 'ticket_dt', width: '120px'},
        { text: 'Ticket On', value: 'ticket_on' },
        { text: 'Community Name', value: 'comm_name', width: '150px' },
        { text: 'Ticket Title', value: 'ticket_title' },
        { text: 'Raised By', value: 'comp_by' },
        { text: 'Raised Mode', value: 'raised_mode' },
        { text: 'Ticket Status', value: 'ticket_status' }
      ],
      lTimeLine: {},
      showTimeline: false,
      beforeChangeHashTicket: '',
      beforeChangeHashTicketDetail: '',
      commList: []
    }
  },
  computed: {
    today: function () {
      return handy.formatDBDate(Date())
    }
  },
  mounted () {
    this.loadBBTickets()
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    loadBBTickets () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getOpenTicketsByVendorId/', qry)
      .then(response => {
        this.ticketList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
        this.ticketList = []
      })
    },
    loadCommunity () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getCommunityByVendorId/' , qry)
      .then(response => {
        this.commList = response.data
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    searchCustomerDet () {
      var qry = {
        params: {
          contact_phone: this.lTicket.comp_phone
        }
      }
      this.commList = []
      this.axios.get(config.API_URL + '/getCustomerDetailByPhone/', qry)
      .then(response => {
        if (response.data.length === 0) {
          this.loadCommunity()
          this.msg('No records found', 2)
        }
        if (response.data.length > 0) {
          this.lTicket.comp_by = response.data[0].cust_name
          this.lTicket.contact_email = response.data[0].contact_email
          response.data.forEach(rec => {
            if (rec.comm_id) {
              this.commList.push({
                comm_id: rec.comm_id, comm_name: rec.comm_name
              })
            } else {
              this.loadCommunity()
            }
          })
        }
      })
      .catch(err => {
        this.msg(err, 0)
        this.commList = {}
      })
    },
    getEmptyTicket () {
      var emptyTicket = {
        comm_id: '',
        comp_phone: '',
        comp_by: '',
        contact_email: '',
        is_critical: false,
        ticket_desc: '',
        ticket_title: '',
        raised_mode: 'Phone'
      }
      return emptyTicket
    },
    prepareCreate () {
      this.lTicket = this.getEmptyTicket()
      this.lAction = 'create'
      this.commList = []
    },
    cancel () {
      this.lAction = 'view'
    },
    prepareEdit (curTicket) {
      this.lTicket = Object.assign({}, curTicket) // keep the original object safely before changes
      this.lTicket.plan_close_dt = this.lTicket.plan_close_dt ? handy.formatDBDate(this.lTicket.plan_close_dt) : null
      this.lTicket.act_close_dt = null
      this.lTicket.notes = ''
      this.beforeChangeHashTicket = this.lTicket.severity + this.lTicket.plan_close_dt + this.lTicket.act_close_dt
      this.beforeChangeHashTicketDetail = this.lTicket.ticket_status + this.lTicket.notes
      this.showResolve = true
    },
    cancelChanges () {
      this.showResolve = false
      this.beingSaved = false
    },
    saveChanges () {
      if (!this.$refs.lForm.validate()) {
        return
      }
      if ((this.lTicket.ticket_status === 'Resolved' || this.lTicket.ticket_status === 'On-hold') && !this.lTicket.notes) {
        var str = 'Please provide resolution description'
        if (this.lTicket.ticket_status === 'On-hold') {
          str = 'Please provide reason for on-hold'
        }
        this.msg(str, 0)
        return
      } else if (this.lTicket.ticket_status === 'Assigned' && !this.lTicket.assigned_to) {
        this.msg('Please assign to someone', 0)
        return
      }
      var afterChangeHashTicket = this.lTicket.severity + this.lTicket.plan_close_dt + this.lTicket.act_close_dt
      var afterChangeHashTicketDetail = this.lTicket.ticket_status + this.lTicket.notes
      if (this.beforeChangeHashTicket !== afterChangeHashTicket || this.beforeChangeHashTicketDetail !== afterChangeHashTicketDetail) {
        this.lTicket.detail_changed = this.beforeChangeHashTicketDetail !== afterChangeHashTicketDetail
      } else {
        this.msg('No changes made to save', 0)
        return
      }
      this.beingSaved = true
      this.lTicket.vendor_id = config.VENDOR_ID
      this.lTicket.vendor_name = config.VENDOR_NAME
      this.lTicket.comp_by_user_id = this.lTicket.user_id
      this.lTicket.user_id = config.SV_USER_ID
      this.lTicket.user_display_name = config.USER_NAME
      if (this.lTicket.ticket_status === 'Resolved' && !this.lTicket.act_close_dt) {
        this.lTicket.act_close_dt = this.today
      }
      this.axios.post(config.API_URL + '/ticket/update', this.lTicket)
      .then(response => {
        var idx = this.ticketList.findIndex(obj => obj.ticket_no === this.lTicket.ticket_no)
        Object.assign(this.ticketList[idx], this.lTicket)
        this.showResolve = false
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.beingSaved = false
      })
    },
    createTicket () {
      // validate and save Changes
      if (!this.$refs.cForm.validate()) {
        return
      }
      this.beingSaved = true
      // fill in the gaps
      this.lTicket.severity = this.lTicket.is_critical ? 'Critical' : 'Normal'
      this.lTicket.vendor_id = config.VENDOR_ID
      this.lTicket.vendor_name = config.VENDOR_NAME
      this.lTicket.user_id = config.SV_USER_ID
      this.lTicket.user_display_name = config.USER_NAME
      this.lTicket.ticket_status = 'New'
      this.axios.post(config.API_URL + '/ticket/create', this.lTicket)
      .then(response => {
        // refresh the ticket list
        this.loadBBTickets()
        this.lAction = 'view'
        this.beingSaved = false
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.beingSaved = false
      })
    },
    loadTimeLine (curTicket) {
      var qry = {
        params: {
          ticket_no: curTicket
        }
      }
      this.axios.get(config.API_URL + '/getTimelineDetailsByTicketNo/', qry)
      .then(response => {
        this.lTimeLine = response.data
        this.showTimeline = true
      })
      .catch(err => {
        this.msg(err.response.data, 0)
        this.showTimeline = false
        this.lTimeLine = []
      })
    }
  }
}
</script>
